var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.99 4.803a2 2 0 0 0-1.383-1.707L8 11.213V21H18.29l.09-.003a1 1 0 0 0 .91-.847v-.002l1.38-8.998.01-.108a1.005 1.005 0 0 0-.59-.954 1 1 0 0 0-.312-.083L19.671 10H14a1 1 0 0 1-1-1V5zM3 20a1 1 0 0 0 1 1h2v-9H4a1 1 0 0 0-1 1zM15 8h4.66a3 3 0 0 1 2.988 3.45v.001l-1.38 9A3 3 0 0 1 18.28 23V23H4a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h2.35l3.736-8.406.07-.13A1 1 0 0 1 11 1a4 4 0 0 1 4 4z"
  })));
};
export default Svg24;